import React, { useEffect } from "react";

const openModals = [];

export function PWSWorkModal({ title, onClose, children, testId = "pws-work-modal", stacked = false, closeTestId = "work-modal-close", size = "", skin = "", subtitle = "" }) {
  useEffect(() => {
    openModals.push(onClose);
    function onKey(event) {
      if (event.key !== "Escape") return;
      if (openModals[openModals.length - 1] !== onClose) return;
      onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => {
      const index = openModals.lastIndexOf(onClose);
      if (index >= 0) openModals.splice(index, 1);
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <div className={`pws-work-modal${stacked ? " pws-work-modal--stack" : ""}${size === "map" ? " pws-work-modal--map" : ""}`} role="dialog" aria-modal="true" aria-label={title} data-testid={testId}>
      <button type="button" className="pws-work-modal__backdrop" aria-label={title} onClick={onClose} />
      <section className={`pws-work-modal__panel${skin ? ` is-${skin}` : ""}`} data-surface="dark">
        <header className="pws-work-modal__head">
          <div>
            <h2>{title}</h2>
            {subtitle ? <p className="og-kicker">{subtitle}</p> : null}
          </div>
          <button type="button" className="pws-work-modal__close" data-testid={closeTestId} onClick={onClose}>
            ×
          </button>
        </header>
        <div className="pws-work-modal__body">{children}</div>
      </section>
    </div>
  );
}
